import axios from "./axios";
import qs from "qs";

export default {
  fetchRefunds(params) {
    return axios.get("/node/fetchRefunds", {
      params: params,
    });
  },
  fetchRefundPurchaseRecords(params) {
    return axios.get("/node/fetchRefundPurchaseRecords", {
      params: params,
    });
  },
  createRefundFromPurchases(data) {
    return axios.post("/node/createRefundFromPurchases", qs.stringify(data));
  },
  updateRefundStatus(data) {
    return axios.post("/node/updateRefundStatus", qs.stringify(data));
  },
  updateRefundAttachment(data) {
    return axios.post("/node/updateRefundAttachment", qs.stringify(data));
  },
};
